import Layout from "../../Layouts";
import InfoIcon from "../../Assets/Icons/outline/info-circle-black.svg";
import DesignIcon from "../../Assets/Images/design-district.png";
import PattternInfo from "../../Assets/Images/pattern-info.png";
import { useContext, useEffect, useState } from "react";
import AdminContext from "../../Services/Admin";
import moment from "moment";

function InformationPage() {
  const { loading, getAllMaster } = useContext(AdminContext);
  const [dataNotification, setDataNotification] = useState([]);

  const getDataNotification = async () => {
    const newData = await getAllMaster(`master/member/notification/all`);
    if (newData) {
      setDataNotification(newData);
    }
  };

  useEffect(() => {
    getDataNotification();
  }, []);

  return (
    <Layout title={"Notification"} icon={InfoIcon}>
      <div className="h-[calc(100vh-200px)] overflow-y-auto">
        {dataNotification.map((item, index) => (
          <div className="flex items-center">
            <div className="p-1 border rounded-full me-3 bg-gray-100">{index + 1}</div>
            <div
              key={index}
              className="text-start py-1 px-4 border rounded-2xl mb-2 w-full bg-gray-100 me-3 "
            >
              {item?.message}
            </div>
            <div className="w-[100px] p-1 border rounded-2xl me-3 bg-gray-100">{moment(item?.created_at).format("DD/MM/YYYY")}</div>
          </div>
        ))}
      </div>
    </Layout>
  );
}

export default InformationPage;
